// extracted by mini-css-extract-plugin
export default {"title":"LegendTitleBase_title__CnnLl"};